(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sale-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

    const padTime = (value) => String(value).padStart(2, '0');

    const timeUntilNextMidnight = () => {
      const now = Date.now();
      const istNow = new Date(now + IST_OFFSET_MS);
      const nextMidnight =
        Date.UTC(istNow.getUTCFullYear(), istNow.getUTCMonth(), istNow.getUTCDate() + 1) - IST_OFFSET_MS;
      const totalSeconds = Math.max(0, Math.ceil((nextMidnight - now) / 1000));

      return {
        hours: padTime(Math.floor(totalSeconds / 3600)),
        minutes: padTime(Math.floor((totalSeconds % 3600) / 60)),
        seconds: padTime(totalSeconds % 60),
      };
    };

    const updateCountdown = () => {
      const time = timeUntilNextMidnight();
      const signature = `${time.hours}:${time.minutes}:${time.seconds}`;

      document.querySelectorAll('[data-sale-countdown]').forEach((countdown) => {
        if (countdown.dataset.time === signature) return;

        const hours = countdown.querySelector('[data-sale-countdown-hours]');
        const minutes = countdown.querySelector('[data-sale-countdown-minutes]');
        const seconds = countdown.querySelector('[data-sale-countdown-seconds]');
        if (!hours || !minutes || !seconds) return;

        countdown.dataset.time = signature;
        hours.textContent = time.hours;
        minutes.textContent = time.minutes;
        seconds.textContent = time.seconds;
        countdown.setAttribute(
          'aria-label',
          countdown.dataset.accessibleTemplate
            .replace('__HOURS__', time.hours)
            .replace('__MINUTES__', time.minutes)
            .replace('__SECONDS__', time.seconds),
        );
      });
    };

    updateCountdown();
    window.setInterval(updateCountdown, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
